<template>
  <div class="breadcrumb-component">
    <a-breadcrumb v-if="titles.length > 1">
      <a-breadcrumb-item v-for="item in titles" :key="item">
        <span :class="[item.path ? 'to-path' : '']" @click="() => toPath(item.path, item.query)">
          {{ item.name }}
        </span>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <div class="current-title" v-if="showTitle">
      <div>{{ getCurrentTitle(titles) }}</div>
      <slot name="breadcrumb" />
    </div>
  </div>
</template>

<script>
import { Breadcrumb } from "ant-design-vue";
import { useRouter } from "vue-router";
const BreadcrumbItem = Breadcrumb.Item;

export default {
  name: "tsl-breadcrumb",
  components: {
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Breadcrumb.name]: Breadcrumb
  },
  props: {
    titles: {
      type: Array,
      default: () => []
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const router = useRouter();
    const toPath = (path, query) => {
      if (!path) return;
      router.push({ path, query });
    };
    const getCurrentTitle = (titles) => {
      if (titles && Array.isArray(titles) && titles.length) {
        return titles[titles.length - 1].name;
      }
    };
    return { toPath, getCurrentTitle };
  }
};
</script>

<style lang="less" scoped>
.breadcrumb-component {
  padding: 8px 24px 16px 24px;
  text-align: left;
  background-color: @base-bg-default-color;
  .ant-breadcrumb {
    font-size: @font-size-xs;
    line-height: 20px;
  }
  .current-title {
    display: flex;
    justify-content: space-between;
    margin-top: @margin-md;
    color: @text-color-primary;
    font-weight: @font-weight-bold;
    font-size: @font-size-lg;
    line-height: 32px;
  }
  .to-path {
    cursor: pointer;
    &:hover {
      color: @text-color-primary;
    }
  }
}
</style>
